module.exports = __webpack_public_path__ + "media/newstyle/images/word-message-cd1c05c80e9dfb06acdb283be43e2902.svg";